export default __webpack_public_path__ + "static/media/idea-mapping.f6d09e59.svg";